import React, { useState } from 'react';
import ThemeLogo from '../theme/ThemeLogo';
import './UploadImage.scss';

const UploadImage = ({ onImageUpload }) => {
  const [image, setImage] = useState(null);

  const handleImageChange = event => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl);
      if (onImageUpload) {
        onImageUpload(file);
      }
    }
  };

  return (
    <div className='upload-container'>
      <input type='file' id='fileUpload' accept='image/*' onChange={handleImageChange} className='file-input' />
      <label htmlFor='fileUpload' className='upload-label'>
        {image ? <img src={image} alt='Uploaded' className='uploaded-image' /> : <div className='placeholder'>Upload PFP</div>}
        <div className='overlay'>
          <ThemeLogo icon={'camera'} className={'camera-icon'} />
        </div>
      </label>
    </div>
  );
};

export default UploadImage;
